module.exports = __webpack_public_path__ + "static/media/commissions1.83e1d0ac.png";